// Helper: build a fully-qualified <img src> URL for a stored profile photo.
// Backend returns a relative path like "/api/files/<file_id>" and we must
// append the current auth token via ?auth=<token> because <img> tags can't
// send Authorization headers.

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

export function profileImageSrc(url) {
  if (!url) return "";
  const token = typeof window !== "undefined" ? localStorage.getItem("pragma_token") : null;
  const base = url.startsWith("http") ? url : `${BACKEND_URL}${url}`;
  if (!token) return base;
  const sep = base.includes("?") ? "&" : "?";
  return `${base}${sep}auth=${encodeURIComponent(token)}`;
}
